/* ==========================================================================
   Dapper Singh — Shared Component JS
   File: assets/ds-components.js
   Branch: feature/summer-of-sol
   Minimal vanilla JS utilities shared across ds- sections.
   ========================================================================== */

(function () {
  'use strict';

  // Modal open/close
  function initModals() {
    document.querySelectorAll('[data-ds-modal-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var targetId = trigger.getAttribute('data-ds-modal-open');
        var modal = document.getElementById(targetId);
        if (modal) {
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
      });
    });

    document.querySelectorAll('[data-ds-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var modal = btn.closest('.ds-modal-overlay');
        if (modal) {
          modal.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    });

    // Close on overlay click
    document.querySelectorAll('.ds-modal-overlay').forEach(function (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
          overlay.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.ds-modal-overlay.is-open').forEach(function (modal) {
          modal.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      }
    });
  }

  // Announcement bar dismiss
  function initAnnouncementBar() {
    var bar = document.querySelector('[data-ds-announcement-bar]');
    var dismiss = document.querySelector('[data-ds-announcement-dismiss]');
    if (!bar || !dismiss) return;

    dismiss.addEventListener('click', function () {
      bar.style.display = 'none';
      try {
        sessionStorage.setItem('ds-announcement-dismissed', '1');
      } catch (e) {}
    });

    try {
      if (sessionStorage.getItem('ds-announcement-dismissed')) {
        bar.style.display = 'none';
      }
    } catch (e) {}
  }

  // Testimonial carousel (simple auto-advance)
  function initTestimonials() {
    document.querySelectorAll('[data-ds-testimonials]').forEach(function (carousel) {
      var slides = carousel.querySelectorAll('[data-ds-testimonial-slide]');
      if (slides.length <= 1) return;

      var current = 0;
      var autoplay = carousel.getAttribute('data-ds-autoplay') === 'true';
      var speed = parseInt(carousel.getAttribute('data-ds-speed') || '4', 10) * 1000;

      function show(index) {
        slides.forEach(function (s) { s.setAttribute('aria-hidden', 'true'); s.style.display = 'none'; });
        slides[index].removeAttribute('aria-hidden');
        slides[index].style.display = 'block';
      }

      show(0);

      if (autoplay) {
        setInterval(function () {
          current = (current + 1) % slides.length;
          show(current);
        }, speed);
      }

      // Prev/Next buttons
      var prev = carousel.querySelector('[data-ds-testimonial-prev]');
      var next = carousel.querySelector('[data-ds-testimonial-next]');

      if (prev) {
        prev.addEventListener('click', function () {
          current = (current - 1 + slides.length) % slides.length;
          show(current);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          current = (current + 1) % slides.length;
          show(current);
        });
      }
    });
  }

  // Init on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initModals();
      initAnnouncementBar();
      initTestimonials();
    });
  } else {
    initModals();
    initAnnouncementBar();
    initTestimonials();
  }

})();
